/* global process */

/*
if ("production" !== process.env.NODE_ENV) {
    alert('foo');
} else {
    alert('bar');
}
*/
import axios from 'axios';
import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const dataSourcePath = process.env.DATA_SOURCE_PATH || process.env.$bamboo_DATA_SOURCE_PATH || './';
console.log('process.env', dataSourcePath, process.env)
const environments = {
	'production': {
		'2015': {
			results: `${dataSourcePath}/static/publicResults_2015.json`,
			map: `${dataSourcePath}/static/state_electoral_boundaries_2008.json`
		},
		'2017': {
			results: 'https://s3-ap-southeast-2.amazonaws.com/wildlings-electionresults-static-prod/publicResults_2017.json', // `${dataSourcePath}/static/publicResults_2017.json`,
			map: `${dataSourcePath}/static/state_electoral_boundaries_2017.json`,
			calledseats: 'https://s3-ap-southeast-2.amazonaws.com/wildlings-electionresults-static-prod/called_seats_2017.json'
		}
	},
	'development': {
		'2015': {
			results: './static/publicResults_2015.json',
			map: './static/state_electoral_boundaries_2008.json'
		},
		'2017': {
			results: 'https://s3-ap-southeast-2.amazonaws.com/wildlings-electionresults-static-prod/publicResults_2017.json', //'./static/publicResults_2017.json',
			map: './static/state_electoral_boundaries_2017.json',
			// calledseats: './static/called_seats_2017.json'
			calledseats: 'https://s3-ap-southeast-2.amazonaws.com/wildlings-electionresults-static-prod/called_seats_2017.json'
		}
	}
};

const dataSources = environments[process.env.NODE_ENV || 'development'];


const store = new Vuex.Store({
	state: {
		dataSources,
		loading: false,
		currentYear: 2017,
		timer: 120000,
		elections: {
			'2015': {
				year: 2015,
				order:1,
				enabled: true,
				data: {
					results: null,
					map: null,
					calledseats: null
				}
			},
			'2017': {
				year: 2017,
				order: 0,
				navDisabled: false, // !location.search.match('show_election_2017'),
				enabled: true,// location.search.match('show_election_2017'),
				live: true, //true,
				data: {
					results: null,
					map: null,
					calledseats: null
				}
			}
		}
	},
	getters: {
		resultsEndpoint: ( state ) => (year = state.currentYear) => {
			// Endpoint year defaults to currentYear
			return state.dataSources[year].results;
		},
		calledSeatsEndpoint: ( state ) => (year = state.currentYear) => {
			// Endpoint year defaults to currentYear
			// console.log('calledSeatsEndpoint', year, state.dataSources, state.dataSources[year].calledseats);
			return state.dataSources[year].calledseats;
		},
		mapEndpoint: ( state ) => (year = state.currentYear) => {
			// Endpoint year defaults to currentYear
			return state.dataSources[year].map;
		},
		currentElection: (state) => (year = state.currentYear) => {
			return state.elections[year];
		},
		results: (state, getters) => (year = state.currentYear) => {
			return getters.currentElection(year).data.results;
		},
		map: (state, getters) => (year = state.currentYear) => {
			return getters.currentElection(year).data.map;
		},
		calledseats: (state, getters) => (year = state.currentYear) => {
			return getters.currentElection(year).data.calledseats;
		},
		parties: ( state, getters ) => (year = state.currentYear) => {
			return getters.results(year) && getters.results(year).parties || [];
		},
		districts: ( state, getters ) => (year = state.currentYear) => {
			return getters.results(year) && getters.results(year).districts || [];
		},
		getDistrictById: ( state, getters ) => (_id, year = state.currentYear) => {

			if (getters.results(year) && _id) {
				const
					id = parseInt(_id, 10),
					district = getters.districts(year)[id - 1] || {},
					directMatch = district && parseInt(district['number'], 10) === id;

				return directMatch ? district : getters.districts(year).find( (district) => {
						return parseInt(district['number'], 10) === id;
					});
			}

			return null;
		},
		percentCounted: ( state, getters ) => (year = state.currentYear) => {
			return 	getters.results(year) && getters.results(year).percentRollCounted ||
					getters.calledseats(year) && getters.calledseats(year).percentRollCounted;
		}
		/*,
		getPartyByCode: ( state, getters ) => (code) => {
			return getters.results && code ?
				getters.parties.find( (party) => party['code'] === code)
				: null;
		}*/
	},
	mutations: {
		loading: (state, isLoading) => {
			state.loading = isLoading;
		},
		loadData: (state, payload) => {
			const {
				year = state.currentYear
			} = payload;
			// console.log('payload', payload, payload.year, year)
			// Using object assign instead of replacing object to ensure reactivity.
			Object.assign(state.elections[year].data, {
				...payload.data
			});
		},
		currentYear: (state, year) => {
			state.currentYear = year;
		}
	},
	actions: {
		loadResults: ({ commit, getters, state, dispatch }, year) => {
			clearTimeout(state.timeout);
			const
				existingData = getters.results(year),
				isLive = getters.currentElection(year).live;

			return new Promise( (resolve, reject) => {

				if (existingData && !isLive) {
					// console.log(`Already have results data for ${year}: `, existingData);
					commit('loadData', existingData);
					dispatch('scheduleUpdate', year)

					resolve(existingData);
					return existingData;
				}

				axios.get(getters.resultsEndpoint(year))
					.then( (response) => {
						const payload = {
							year,
							data: { results: response.data }
						};
						commit('loadData', payload);

						dispatch('scheduleUpdate', year)
						resolve(response);
					})
					.catch( (err) => {
						commit('loading', false);
						reject(err);
					});
			});
		},
		loadMap: ({ commit, getters, state }, year) => {

			const existingData = getters.map(year);

			return new Promise( (resolve, reject) => {

				if (existingData) {
					// console.log(`Already have map data for ${year}: `, existingData);
					commit('loadData', existingData);
					resolve(existingData);
					return existingData;
				}

				// commit('loading', true);

				axios.get(getters.mapEndpoint(year)) //'/static/state_electoral_boundaries_2017.json'
					.then( (response) => {
						const payload = {
							year,
							data: { map: response.data }
						};
						commit('loadData', payload);
						// const loadingTimeout = setTimeout(() => { commit('loading', false); }, 500);
						resolve(response);
					})
					.catch( (err) => {
						commit('loading', false);
						reject(err);
					});
			});
		},
		loadCalledSeats: ({ commit, getters, state, dispatch }, year) => {
			clearTimeout(state.timeout);
			// const
				// existingData= getters.results(year),
				// isLive = getters.currentElection(year).live;

			return new Promise( (resolve, reject) => {
				/*
				if (existingData && !isLive) {
					console.log(`Already have Called Seats data for ${year}: `, existingData);
					commit('loadData', existingData);
					dispatch('scheduleUpdate', year)

					resolve(existingData);
					return existingData;
				}*/

				const endpoint =  getters.calledSeatsEndpoint(year);
				if (!endpoint) resolve();

				axios.get(getters.calledSeatsEndpoint(year))
					.then( (response) => {
						const payload = {
							year,
							data: { calledseats: response.data }
						};
						// console.log(payload)
						commit('loadData', payload);

						dispatch('scheduleUpdate', year)
						resolve(response);
					})
					.catch( (err) => {
						commit('loading', false);
						reject(err);
					});
			});
		},
		changeYear: ({ commit, state, dispatch }, year ) => {
			commit('loading', true);
			clearTimeout(state.timeout);

			Promise.all([
				dispatch('loadMap', year),
				dispatch('loadResults', year),
				dispatch('loadCalledSeats', year)

			]).then(() => {
				console.log('changeYear: all promises fullfilled');
				commit('currentYear', year);
				commit('loading', false);
				dispatch('scheduleUpdate');
			}).catch( (err) => {
				commit('loading', false);
				throw err;
			});
		},
		loadAllResults: ({ commit, dispatch }) => {
			commit('loading', true);
			Promise.all([
				dispatch('loadResults'),
				dispatch('loadCalledSeats')
			])
			.then( () => commit('loading', false) )
			.catch( (err) => {
				commit('loading', false);
				throw err;
			});
		},
		scheduleUpdate: ({ state, getters, dispatch, commit }, year = state.currentYear) => {

			if (getters.currentElection(year).live) {
				if (!state.timeout) {
					console.log('Selected election is live. scheduleUpdate: ', new Date(), this.$root)
				} else {
					console.log('Selected election is live. Already has a timer - Clear and scheduleUpdate: ', state.timer, new Date() );
				}

				clearTimeout(state.timeout);

				state.timeout = setTimeout(() => {
					dispatch('loadAllResults');
				}, state.timer);
			} else {
				console.log('Selected election not live. No need to scheduleUpdate')
			}
		}
	}
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js